/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { Col, Row } from 'react-bootstrap';
import {
    AccordionItem, AccordionItemBody, AccordionItemHeader, Accordions, Button, Input, Select, SelectOption, Table, TextArea,
} from 'appkit-react';

import TestRegex from './TestRegex';

const AddRule = ({
    ruleName, setRuleName, ruleNameError, ruleDescription, setRuleDescription,
    ruleDescriptionError, dimension, setDimension, dimensionError, dimensions,
    filterType, setFilterType, filterTypeError, filterTypes, filterExpression,
    setFilterExpression, filterExpressionError, validationInput, onValidateRule,
    isTestRegexLoading, handleValidationInput, addNewInput, regExResult, removeInput,
    setShowAddRuleModal, onTabOneSave, uperstRuleLoader, activeAccordionItems,
    fieldsTitle, onAddNewRule, rules, tableColumns, showFields,
}) => {
    const inputErrorStyle = '0 0 0 0.125rem #c52a1a';
    return (
        <>
            <Accordions activeItem={activeAccordionItems} size="lg">
                <AccordionItem itemId="panel-1" size="lg">
                    <AccordionItemHeader
                        className="background-white header"
                        title="RULES"
                    >
                        <span style={{ marginLeft: '48rem' }}>
                            <Button kind="secondary" size="md" onClick={onAddNewRule}> ADD NEW </Button>
                        </span>
                    </AccordionItemHeader>
                    <AccordionItemBody className="background-white" size="lg">

                        <div style={{ paddingTop: '0rem' }}>
                            <Table
                                data={(rules?.data?.DQgetRules) || []}
                                columns={tableColumns}
                                defaultPageSize={10}
                                sortable
                                size="md"
                                resizable
                                showPageSizeOptions={false}
                            />
                        </div>
                    </AccordionItemBody>
                </AccordionItem>
            </Accordions>
            {showFields
                && (
                    <>
                        <Accordions activeItem={activeAccordionItems} size="lg">
                            <AccordionItem itemId="panel-2" size="lg" style={{ marginTop: '1rem' }}>
                                <AccordionItemHeader
                                    className="background-white header"
                                    title={fieldsTitle}
                                />
                                <AccordionItemBody className="background-white" size="lg" style={{ height: '350px', overflowY: 'scroll' }}>
                                    <Row className="Rules-form-fields">
                                        <Col>
                                            <label className="form-label">
                                                NAME
                                                <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                                            </label>
                                            <Input
                                                type="text"
                                                name="ruleName"
                                                value={ruleName}
                                                onChange={e => {
                                                    setRuleName(e);
                                                }}
                                                hasError={ruleNameError}
                                                errMsg="Name is required"
                                            />

                                            <label className="form-label">
                                                DESCRIPTION
                                                <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                                            </label>
                                            <TextArea
                                                type="text"
                                                name="ruleDescription"
                                                value={ruleDescription}
                                                onChange={e => {
                                                    setRuleDescription(e);
                                                }}
                                                style={{
                                                    boxShadow: ruleDescriptionError
                                                        ? inputErrorStyle
                                                        : '',
                                                    borderRadius: '1px',
                                                    marginBottom: ruleDescriptionError
                                                        ? '0.4rem'
                                                        : '',
                                                }}
                                            />
                                            {ruleDescriptionError && <span className="error-message">DESCRIPTION is required</span>}
                                        </Col>
                                        <Col>
                                            <label className="form-label">
                                                DIMENSION
                                                <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                                            </label>
                                            <Select
                                                placeholder=""
                                                onSelect={e => { setDimension(e); }}
                                                value={dimension}
                                                name="dimension"
                                                dropdownRenderMode="portal"
                                                style={{
                                                    boxShadow: dimensionError
                                                        ? inputErrorStyle : '',
                                                    borderRadius: '1px',
                                                }}
                                            >
                                                {dimensions.data && dimensions.data.DQgetDimensions.map(({ dimensionId, dimensionName }) => (
                                                    <SelectOption key={dimensionId} value={dimensionId}>
                                                        {dimensionName}
                                                    </SelectOption>
                                                ))}
                                            </Select>
                                            {dimensionError && <div className="error-message">DIMENSION is required</div>}
                                            <label className="form-label">
                                                FILTER TYPE
                                                <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                                            </label>
                                            <Select
                                                placeholder=""
                                                onSelect={e => { setFilterType(e); }}
                                                value={filterType}
                                                name="filterType"
                                                dropdownRenderMode="portal"
                                                style={{ boxShadow: filterTypeError ? inputErrorStyle : '', borderRadius: '1px' }}
                                            >
                                                {filterTypes.data && filterTypes.data.DQgetFilterTypes.map(type => (
                                                    <SelectOption key={type.filterTypeId} value={type.filterTypeId}>
                                                        {type.filterType}
                                                    </SelectOption>
                                                ))}
                                            </Select>
                                            {filterTypeError && <div className="error-message">FILTER TYPE is required</div>}
                                            <label className="form-label">
                                                FILTER EXPRESSION
                                                <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
                                            </label>
                                            <Input
                                                type="text"
                                                name="filterExpression"
                                                value={filterExpression}
                                                onChange={e => {
                                                    setFilterExpression(e);
                                                }}
                                                hasError={filterExpressionError}
                                                errMsg="FILTER EXPRESSION is required"
                                            />
                                        </Col>
                                    </Row>
                                    {filterType === 1
                                        && (
                                            <TestRegex
                                                filterExpression={filterExpression}
                                                setFilterExpression={setFilterExpression}
                                                validationInput={validationInput}
                                                onValidateRule={onValidateRule}
                                                isTestRegexLoading={isTestRegexLoading}
                                                handleValidationInput={handleValidationInput}
                                                addNewInput={addNewInput}
                                                regExResult={regExResult}
                                                removeInput={removeInput}
                                            />
                                        )}
                                    <div className="button-comp comment-section" style={{ paddingBottom: '0.5rem' }}>
                                        <Button kind="secondary" gray onClick={() => setShowAddRuleModal(false)} size="lg"> CANCEL </Button>
                                        <Button kind="primary" size="lg" onClick={onTabOneSave} isLoading={uperstRuleLoader}> SAVE </Button>
                                    </div>
                                </AccordionItemBody>
                            </AccordionItem>
                        </Accordions>
                    </>
                )}
        </>
    );
};

export default AddRule;
